/* eslint-disable no-undef */
/* eslint-disable no-plusplus */
import request from 'api/request';

async function readFile(file, type = 'base64') {
  return new Promise((resolve, reject) => {
    // eslint-disable-next-line no-undef
    const reader = new FileReader();
    reader.onloadend = () => resolve(reader.result);
    reader.onerror = reject;
    if (type === 'base64') {
      reader.readAsDataURL(file);
    }
    if (type === 'arrayBuffer') {
      reader.readAsArrayBuffer(file);
    }
  });
}

async function convertFileToBase64(file) {
  const dataUrl = await readFile(file, 'base64');
  return dataUrl;
}

function convertDataUrlToFile(dataUrl, filename) {
  const arr = dataUrl.split(',');
  const mime = arr[0].match(/:(.*?);/)[1];
  const bstr = atob(arr[1]);
  let n = bstr.length;
  const u8arr = new Uint8Array(n);

  while (n--) {
    u8arr[n] = bstr.charCodeAt(n);
  }

  return new File([u8arr], filename, { type: mime });
}

async function convertDataUrlToBlob(dataUrl) {
  const arr = dataUrl.split(',');
  const mime = arr[0].match(/:(.*?);/)[1];
  const bstr = atob(arr[1]);
  let n = bstr.length;
  const u8arr = new Uint8Array(n);

  while (n--) {
    u8arr[n] = bstr.charCodeAt(n);
  }

  return new Blob([u8arr], { type: mime });
}

async function readFileFromRemoteUrl(url, options = {}) {
  const { data } = await request.call({
    url,
    method: 'GET',
    responseType: 'blob',
    ...options,
  });
  return data;
}

async function readAndConvertFileFromRemoteUrl(url, options = {}, convertType = 'base64') {
  const file = await readFileFromRemoteUrl(url, options);
  const dataUrl = await readFile(file, convertType);
  return dataUrl;
}

export const FileHelpers = {
  readFile,
  convertFileToBase64,
  convertDataUrlToFile,
  convertDataUrlToBlob,
  readFileFromRemoteUrl,
  readAndConvertFileFromRemoteUrl,
};
